
export class FightIdentClock {
  constructor({
    animate,
    preview,
    update,
    animateOff,
    getVizPage,
    updateVizPage,
    vizSharedMemory,
  }) {
    this.onAir = false;
    this.sendAnimate = animate;
    this.sendAnimateOff = animateOff;
    this.sendPreview = preview;
    this.sendUpdate = update;
    this.getVizPage = getVizPage;
    this.updateVizPage = updateVizPage;
    this.vizSharedMemory = vizSharedMemory;
    this.name = "Fight Ident Clock";
    this.scene = "Fight Ident Clock";
    this.data = [];
    this.page = 120;
  }

  async preview({ options }) {
    this.onAir = false;

    await this.updateData({ options, show: 1 });
    // await this.updateData({ options, show: 2 });
    // await this.updateData({ options, show: 3 });
    // await this.updateData({ options, show: 4 });
    await this.sendPreview("page:read " + this.page);
  }
  async animate({ options }) {
    this.onAir = true;
    this.sendAnimate({ page: this.page });
  }
  animateOff({ options }) {
    this.onAir = false;
    this.sendAnimateOff({ page: this.page });
  }

  async updateData({ options, show }) {
    let xml = await this.getVizPage({ page: this.page, show }).catch((err) => {
      console.log(err);
    });
    if (xml) {
      xml.payload.field.find((item) => {
        return item.attr.name === "101";
      }).value = (options?.game?.home_fighter?.first_name?.toUpperCase()  || "");
      
      xml.payload.field.find((item) => {
        return item.attr.name === "102";
      }).value = (options?.game?.home_fighter?.last_name?.toUpperCase()  || "");

      xml.payload.field.find((item) => {
        return item.attr.name === "103";
      }).value = (options?.game?.away_fighter?.first_name?.toUpperCase()  || "");

      xml.payload.field.find((item) => {
        return item.attr.name === "104";
      }).value = (options?.game?.away_fighter?.last_name?.toUpperCase()  || "");

      xml.payload.field.find((item) => {
        return item.attr.name === "100";
      }).value = (options?.game?.title || "");

      

      await this.updateVizPage({
        page: this.page,
        data: xml,
        escape: false,
        show,
      }).catch((err) => {
        console.log(err);
      });
    }
  }

  update({ options }) {}
}
